<template>
    <div class="pa-5">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field
                            dense
                            hide-details
                            outlined
                            label="Order ID"
                            v-model="subscription.order_id">
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-select
                            dense
                            hide-details
                            outlined
                            :items="['Revenue Sharing']"
                            label="Package Type"
                            v-model="subscription.package_type">
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Client Subscriber"
                            v-model="subscription.client_subscriber">
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Email Subscriber"
                            v-model="subscription.email_subscriber">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Event Details"
                            v-model="subscription.event_details">
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Title"
                            v-model="subscription.title">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            dense
                            outlined
                            hide-details
                            label="Hashtags"
                            v-model="subscription.hashtags">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-menu
                            v-model="menu_start"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="subscription.start_date"
                                    label="Start Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="subscription.start_date"
                                @input="menu = false"
                                ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu
                            v-model="menu_end"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="subscription.start_date"
                                    label="End Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="subscription.start_date"
                                @input="menu = false"
                                ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="subscription.posting_duration"
                            label="Posting Duration"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-select 
                            outlined
                            dense
                            hide-details
                            label="Viewing Duration"
                            :items="['1 Month', 'Lifetime']" 
                            v-model="subscription.viewing_duration">
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-file-input
                            outlined
                            label="Logo"
                            dense
                            hide-details
                            show-size
                            append-icon="mdi-image"
                            prepend-icon=""
                            v-model="subscription.logo"
                        ></v-file-input>
                    </v-col>
                    <v-col>
                        <v-file-input
                            outlined
                            label="Backgroud"
                            dense
                            hide-details
                            show-size
                            append-icon="mdi-image"
                            prepend-icon=""
                            v-model="subscription.background"
                        ></v-file-input>
                    </v-col>
                    <v-col>
                        <v-file-input
                            outlined
                            label="Post Banner"
                            dense
                            hide-details
                            show-size
                            append-icon="mdi-image"
                            prepend-icon=""
                            v-model="subscription.post_banner"
                        ></v-file-input>
                    </v-col>
                    <v-col>
                        <v-text-field 
                            outlined
                            dense
                            hide-details
                            label="Theme"
                            v-model="subscription.color"
                            readonly
                            @click="colorpicker = true">
                            <v-icon :color="subscription.color" 
                                slot="append" 
                                @click="colorpicker = true">
                                mdi-circle
                            </v-icon>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <v-text-field
                            type="number"
                            outlined
                            dense
                            label="Rotation Control Duration (minutes)"
                            v-model="subscription.rotation_interval"
                            append-icon="mdi-clock">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        :input-value="true"
                        disabled
                        label="Can Post Photo"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.can_post_video"
                        label="Can Post Video"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.can_post_message"
                        label="Can Post Messages"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.show_timestamp"
                        label="Show Timestamp"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.allow_comment"
                        label="Viewers Can Comment"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.allow_reaction"
                        label="Viewers Can React"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.display_timer"
                        label="LIVE VOTE Display Timer"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.display_pay_button"
                        label="LIVE VOTE Pay Button"
                        ></v-checkbox>
                    </v-col>
                    <v-col>
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.display_vote_count"
                        label="LIVE VOTE Display Votes"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="4" md="6" sm="12">
                        <v-checkbox
                        dense
                        hide-details
                        v-model="checkbox"
                        label="LIVE VOTE Event Introduction"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" lg="4" md="6" sm="12">
                        <v-checkbox
                        dense
                        hide-details
                        v-model="subscription.share_button"
                        label="LIVE VOTE Share to Social Media"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" lg="4" md="4" sm="12">
                        <v-file-input
                            outlined
                            label="LIVE VOTE Event Header"
                            dense
                            hide-details
                            show-size
                            append-icon="mdi-image"
                            prepend-icon=""
                            v-model="subscription.lv_event_header"
                        ></v-file-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-menu
                            v-model="menu_voting_start_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="subscription.lv_start_date"
                                    label="Voting Start Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="subscription.lv_start_date"
                                @input="menu = false"
                                ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu
                            v-model="menu_voting_end_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="subscription.lv_end_date"
                                    label="Voting End Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="subscription.lv_end_date"
                                @input="menu = false"
                                ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu
                            v-model="menu_final_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="subscription.lv_final_date"
                                    label="Final Event Date"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="subscription.lv_final_date"
                                @input="menu = false"
                                ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveSubscription">
                    <v-icon>mdi-check</v-icon> Submit
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog max-width="300" v-model="colorpicker">
            <v-card>
                <v-color-picker
                    dot-size="27"
                    hide-mode-switch
                    hide-sliders
                    show-swatches
                    hide-canvas
                    mode="hexa"
                    v-model="selectedColor"
                    @input="setColor(selectedColor.hex)"
                ></v-color-picker>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small text @click="colorpicker = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'NewVotingSubscriptionView',
    data() {
        return {
            subscription : {},
            menu_start: false,
            menu_end: false,
            menu_voting_start_date: false,
            menu_voting_end_date: false,
            menu_final_date: false,
            colorpicker : false,
            selectedColor : {
                hex: '#FF0000FF' // Default color
            },
        };
    },
    methods: {
        saveSubscription() {
            const formData = new FormData();
            for (const key in this.subscription) {
                // If the value is a File (from v-file-input), append it directly
                if (this.subscription[key] instanceof File) {
                    formData.append(key, this.subscription[key]);
                } else {
                    formData.append(key, this.subscription[key]);
                }
            }
            axios.post('/api/voting-subscriptions', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(response => {
                this.$router.push({ name: 'VotingSubscriptions' });
            })
            .catch(error => {
                console.error('Error saving subscription:', error);
                // Handle error appropriately, e.g., show a notification
            });
        },
        setColor(color) {
            this.subscription.color = color;
            // Logic to validate or process the selected color
        }
    }
};
</script>